import React from 'react'
import {makeStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const useStyles = makeStyles({
    StyledHead: {
      backgroundColor:"#44979e"
    },
    OrderAvaliableColumn:{
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        color:"white",
        fontFamily:"Microsoft JhengHei",
        fontSize:12,
        cursor:"pointer",
        '&:hover':{
            backgroundColor:"#a1d8ff",
        },
        backgroundColor:"#5f9ea0"
    },

    OrderNotAvaliableColumn:{
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        color:"white",
        fontFamily:"Microsoft JhengHei",
        fontSize:12,
        backgroundColor:"#5f9ea0",
        cursor:"pointer",
    },
    OrderColumnCell:{
        borderStyle:"soild",
        borderWidth:1,
        borderColor:"black",
        color:"black",
        fontFamily:"Microsoft JhengHei",
        fontSize:12,
        backgroundColor:"#ffe736",
        cursor:"pointer",
    },
    OrderIcon:{
        color:"#008cff"
    }
  });
  

export default function RecordStyledTableHead(props) {
    const classes = useStyles();
    function CellGroup() {
        let result
        if(props.columnStatus)
        {
            console.log("CellGroup A1")
            let temp = []
            props.columnStatus.forEach(element => {
                if(element.status)
                {
                    temp.push(element)
                }
            });

            result = temp.map((column,index)=>{
            return  <TableCell style={{width:column.width+"px"}}className={props.orderColumn === column.columnName?classes.OrderColumnCell:classes.OrderAvaliableColumn} key={index} align="left" onClick={()=>props.getNewOrderStatus(column.columnName)}>{column.columnTitle}{props.orderColumn === column.columnName ? props.orderType === "ASC" ? <div className={classes.OrderIcon}>&#9650;</div> : <div className={classes.OrderIcon}>&#9660;</div> :""}</TableCell>
            })
        }
        else
        {
            console.log("CellGroup A2")
            result = null
        }
   
        return result
    }
    
   
    return (
        <TableHead className={classes.StyledHead}>
            <TableRow>
                <TableCell style={{width:"60px"}} className={classes.OrderNotAvaliableColumn} onClick={()=>props.openColumnSelectedModal()}>序號</TableCell> 
                <TableCell style={{width:"150px"}} className={props.orderColumn === "Movie_SysID"?classes.OrderColumnCell:classes.OrderAvaliableColumn} align="left" onClick={()=>props.getNewOrderStatus("Movie_SysID")}>電影系統編號{props.orderColumn === "Movie_SysID" ? props.orderType === "ASC" ? <div className={classes.OrderIcon}>&#9650;</div> : <div className={classes.OrderIcon}>&#9660;</div> :""}</TableCell>
                <TableCell style={{width:"150px"}} className={props.orderColumn === "Movie_TitleMain"?classes.OrderColumnCell:classes.OrderAvaliableColumn} align="left" onClick={()=>props.getNewOrderStatus("Movie_TitleMain")}>主要片名{props.orderColumn === "Movie_TitleMain" ? props.orderType === "ASC" ? <div className={classes.OrderIcon}>&#9650;</div> : <div className={classes.OrderIcon}>&#9660;</div> :""}</TableCell>
                <CellGroup/>
                <TableCell style={{width:"60px"}} className={classes.OrderNotAvaliableColumn} onClick={()=>props.toggleMountOrUnmount()}>上下架</TableCell> 
            </TableRow>
        </TableHead>
    )
}